import React from "react";
import { createUseStyles } from "react-jss";
import { CDN_URL } from "Constants/CDN";
import LazyImage from "ComponentsUI/Image";

const useStyles = createUseStyles((theme) => ({
	img: {
		objectFit: "scale-down",
		width: "50%",
		transition: ".2s",
		"&:hover": {
			transform: "scale(1.5)",
			transition: "1s",
		},
		"&:nth-child(1)": {
			width: "25%",
		},
		"&:nth-child(2)": {
			width: "25%",
		},
		"&:nth-child(9)": {
			width: "25%",
		},
		"&:nth-child(10)": {
			width: "25%",
		},
	},
	[`@media (max-width: ${theme.media.md})`]: {
		img: {
			width: "100%",
			height: "75%",
			"&:nth-child(1)": {
				width: "50%",
			},
			"&:nth-child(2)": {
				width: "50%",
			},
			"&:nth-child(9)": {
				width: "50%",
			},
			"&:nth-child(10)": {
				width: "50%",
			},
		},
	},
}));

const CertificatesBlock = (props) => {
	const { siteCode } = props;
	const classes = useStyles();
	const certificates = {
		101: [
			{ id: 0, name: "Ростелеком" },
			{ id: 1, name: "Уфанет" },
			{ id: 2, name: "Дом.ру" },
			{ id: 3, name: "Google Аналитика" },
			{ id: 4, name: "Яндекс Метрика" },
			{ id: 5, name: "Сотрудника" },
			{ id: 6, name: "Сотрудника" },
			{ id: 7, name: "Сотрудника" },
			{ id: 8, name: "ХХ.ру" },
			{ id: 9, name: "Алмател" },
		],
		MOL: [
			{ id: 0, name: "Ростелеком" },
			{ id: 1, name: "Алмател" },
			{ id: 2, name: "Дом.ру" },
			{ id: 3, name: "Google Аналитика" },
			{ id: 4, name: "Яндекс Метрика" },
			{ id: 5, name: "Сотрудника" },
			{ id: 6, name: "Сотрудника" },
			{ id: 7, name: "Сотрудника" },
			{ id: 8, name: "ХХ.ру" },
			{ id: 9, name: "Сотрудника" },
		],
		POL: [
			{ id: 0, name: "Ростелеком" },
			{ id: 1, name: "СкайНэт" },
			{ id: 2, name: "Дом.ру" },
			{ id: 3, name: "Google Аналитика" },
			{ id: 4, name: "Яндекс Метрика" },
			{ id: 5, name: "Сотрудника" },
			{ id: 6, name: "Сотрудника" },
			{ id: 7, name: "Сотрудника" },
			{ id: 8, name: "ХХ.ру" },
			{ id: 9, name: "Сотрудника" },
		],
	};

	return (
		<div className={classes.root}>
			{certificates[siteCode].map((certificate, index) => {
				return (
					<LazyImage
						width={180}
						height={360}
						src={`${CDN_URL}/images/certificates/${siteCode}/${certificate.id + 1}-min.png`}
						className={classes.img}
						alt={`Сертификат ${certificate.name}`}
						key={index}
					/>
				);
			})}
		</div>
	);
};

export default CertificatesBlock;
